module.exports = __webpack_public_path__ + "img/logo.8f65c93d.svg";